/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_LabelInputs */

const en_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Type`)
};

const fr_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de projet`)
};

const de_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekttyp`)
};

const it_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di progetto`)
};

const ru_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип проекта`)
};

const es_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de proyecto`)
};

const zh_cn2_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目类型`)
};

const ja_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの種類`)
};

const hi_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना प्रकार`)
};

const pt_pt2_new_project_type_label = /** @type {(inputs: New_Project_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de projeto`)
};

/**
* | output |
* | --- |
* | "Project Type" |
*
* @param {New_Project_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_label = /** @type {((inputs?: New_Project_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_type_label(inputs)
	if (locale === "de") return de_new_project_type_label(inputs)
	if (locale === "it") return it_new_project_type_label(inputs)
	if (locale === "ru") return ru_new_project_type_label(inputs)
	if (locale === "es") return es_new_project_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_type_label(inputs)
	if (locale === "ja") return ja_new_project_type_label(inputs)
	if (locale === "hi") return hi_new_project_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_type_label(inputs)
	return en_new_project_type_label(inputs)
});